import * as React from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import styles from '../../styles/forms/contact_product_seller_wizard/ContactProductSellerForm.scss';
import Input from '../../components/Input';
import { __, resetForm, setTableParams } from '../../core/utils';
import Textarea from '../../components/Textarea';
import Button from '../../components/Button';

const ContactProductSellerForm = ({ submit, handleSubmit, submitting }) => {
  return (
    <div className={styles.wrapper}>
      <Form onSubmit={handleSubmit} className={styles.form}>
        <Field
          name='company_email'
          component={Input}
          label={__('products.contact_product_seller.email')}
          disabled
        />

        <Field
          name='subject'
          component={Input}
          label={__('products.contact_product_seller.subject')}
        />
        <Field
          name='message'
          component={Textarea}
          label={__('products.contact_product_seller.message')}
          rows={5}
        />
      </Form>

      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('button.cancel')}
          onClick={() => {
            setTableParams('products', {
              contact_product_seller_wizard: undefined,
            });
          }}
        />
        <Button
          lightBlue
          onClick={() => submit()}
          medium
          spinning={submitting}
          right
          middleText={__('button.send')}
        />
      </div>
    </div>
  );
};

export default reduxForm({
  form: 'contact_product_seller_wizard.contact_product_seller',
})(ContactProductSellerForm);
